import { connect } from 'react-redux';
import { openPanel, focusRestored } from '../../../../shared/actions/sidebar';
import ArticleInfoButton from './articleInfoButton';
import hasConnections from '../../../utils/connections/hasConnections';
import hasRecommendations from '../../../utils/recommendations/hasRecommendations';
import { panelGroup, panelType } from '../../../../shared/constants';
import { shouldRestoreOpenerFocus } from '../../../../shared/actions/sidebarUtils';

function mapStateToProps(state) {
  const {
    connections: { data: connectionsData },
    recommendations: { data: recommendationsData },
    sidebar: { isOpen: sidebarIsOpen },
  } = state;

  const hasArticleInfo = hasConnections(connectionsData)
    || hasRecommendations(recommendationsData);

  return {
    shouldShow: !sidebarIsOpen && hasArticleInfo,
    restoreFocus: shouldRestoreOpenerFocus(state, panelGroup.connections, panelType.articleInfo),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onClick: () => dispatch(openPanel(panelGroup.connections, panelType.articleInfo)),
    focusRestored: () => dispatch(focusRestored()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleInfoButton);
